<script setup lang="ts">
/* Stores */
import { useBasketStore } from '@/store/basket/basket'
import { useBasketChangeStore } from '@/store/basket/basket-change'

type Props = {
  change: number
}
defineProps<Props>()

const basketStore = useBasketStore()
const basketChangeStore = useBasketChangeStore()

const setSelectedChange = (currentChange: number) => {
  basketStore.setChange(currentChange)
}

const changeList = computed(() => {
  return basketChangeStore.choices
})
</script>

<template>
  <div class="change">
    <the-dropdown
      :model-value="change"
      :items="changeList"
      item-title="text"
      item-value="value"
      variant="secondary"
      width="auto"
      @update:model-value="setSelectedChange"
    />
  </div>
</template>

<style lang="scss" scoped>
.change {
  width: 140px;
}
</style>
